import { observer } from 'mobx-react-lite';
import { UnitQueueRowData } from '../../../socket/stream-types';
import { StatusColorCell } from './status-color-cell';

export const StatusCodeColorCodedCell = observer(function StatusCodeColorCodedCell({
    data,
}: {
    data: UnitQueueRowData;
}): React.ReactElement {
    return (
        <StatusColorCell
            data={data}
            value={data.statusCode}
            contentAlignment="CENTER"
        />
    );
});
